// @ts-nocheck
import { useAccount, useMsal } from "components/common/msal";
import * as React from "react";
import {
    BrowserRouter as Router, Switch
} from "react-router-dom";
import * as RoutesModule from "./routes";
import getAuthToken from "./utils/getAuthToken";
import getBaseUrl from "./utils/getBaseUrl";


let routes = RoutesModule.routes;

function isAuthorized() {
    let token = getAuthToken();

    if (token === null) {
        localStorage.removeItem("access_token");
        return false;
    }

    return true;
}

function App({ BQS }) {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const baseUrl = getBaseUrl();

    const environment = window.ENVIRONMENT_VAR;

    const postUserName = async (account, username) => {
        const url = `${getBaseUrl()}api/account/Token`;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username }),
            });

            if (!response.ok) {
                if (response.status == 404) {
                    //instance.logoutRedirect({ account: account });

                    //instance.logout({
                    //    account: account,
                    //    postLogoutRedirectUri: "/login", // Redirect to the login page
                    //    forceLogout: true,
                    //    onRedirectNavigate: () => {
                    //        window.location.href = "https://bqs.localhost:5001/";
                    //    },
                    //});

                    //setRedirectToUnauthorized(true);

                    //localStorage.removeItem("authorization_token");
                }
            }
            else {
                const responseData = await response.json();

                if (responseData !== null) {
                    localStorage.setItem("authorization_token", responseData.authorization_token);
                }
            }

        } catch (error) {
            console.error('Error:', error);
        }

    };
    //console.log('config file: ' + `./config.${environment}.ts`);
    let config = require(`./config.${environment}.ts`) as any;

    const scope = BQS
        ? config.authRequestBQS.scopes[0]
        : config.authRequestCQS.scopes[0];

    if (account) {
        instance
            .acquireTokenSilent({
                scopes: [scope],
                account: account,
            })
            .then((response) => {
                if (response) {
                    localStorage.setItem("access_token", response.accessToken);
                    //console.log("App: Access token acquired silently: ", response.accessToken);

                    let token = localStorage.getItem("authorization_token");

                    if (token === null) {
                        const userName = account.username || account.name;
                        if (userName) {
                            postUserName(account, userName);
                        } else {
                            console.error('App: No username or name available in MSAL account.', account);
                        }
                    }
                }
            })
            .catch((err) => {
                //console.log("App: Silent token acquisition failed, acquiring token interactively...", err);

                instance.loginRedirect({
                    scopes: [scope],
                    account: account
                });
            });

    }

    return (
        <Router basename={baseUrl}>
            <Switch>
                {routes}
            </Switch>
        </Router>
    );
}

export default App;



// WEBPACK FOOTER //
// ./ClientApp/App.tsx